<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="items"
      class="elevation-0"
      :options.sync="options"
      :server-items-length="totalItems"
      :loading="loading"
      item-class="properties"
      :dense="false"
      :key="tableKey"
      :footer-props="footerProps"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            class="black--text font-weight-bold mb-2"
            rounded
            large
            @click="downloadUsers"
            :disabled="downloadLoading"
          >
            <template v-if="downloadLoading">
              <v-progress-circular
                :rotate="360"
                indeterminate
                size="20"
                width="3"
                color="black"
                class="mr-2"
              />
            </template>
            <template v-else>
              <v-icon color="black" small class="mr-2">
                mdi-download
              </v-icon>
              Download
            </template>
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item.status="{ item }">
        <v-chip
          v-if="item.roles[0] === 'provider'"
          outlined
          :color="getChipColor(item)"
          class="font-weight-bold"
        >
          {{ getChipText(item) }}
        </v-chip>
        <v-chip
          v-if="item.roles[0] === 'researcher'"
          outlined
          :color="getChipColor(item)"
          class="font-weight-bold"
        >
          {{ getChipText(item) }}
        </v-chip>
        <v-chip
          v-if="item.roles[0] === 'institution-representative'"
          outlined
          :color="getChipColor(item)"
          class="font-weight-bold"
        >
          {{ getChipText(item) }}
        </v-chip>
      </template>
      <template v-slot:item.firstName="{ item }">
        {{ item.firstname }}
      </template>
      <template v-slot:item.lastName="{ item }">
        {{ item.lastname }}
      </template>
      <template v-slot:item.institution="{ item }">
        <div
          v-if="item.institution === 'unknown'"
          tyle="border-left: 2px solid black !important;"
        ></div>
        <div v-else tyle="border-left: 2px solid black !important;">
          {{ item.institution }}
        </div>
      </template>
      <template v-slot:item.email="{ item }">
        <div>{{ item.email }}</div>
      </template>
      <template v-slot:item.lastLogin="{ item }">
        <div>
          {{ formatDateTime(item.lastLogin) }}
        </div>
      </template>
      <template v-slot:item.firstLogin="{ item }">
        <div>
          {{ formatDateTime(item.firstLogin) }}
        </div>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-layout>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                x-small
                fab
                class="mr-2"
                color="white"
                :to="{ name: 'UserOverview', params: { id: item.id } }"
              >
                <v-icon style="color: rgba(0, 0, 0, 0.87)!important;">
                  mdi-eye-outline
                </v-icon>
              </v-btn>
            </template>
            Overview
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                x-small
                fab
                class="mr-2"
                color="white"
                @click="(itemToBeDeleted = item), (deleteDialog = true)"
              >
                <v-icon style="color: rgba(0, 0, 0, 0.87)!important;">
                  mdi-delete-outline
                </v-icon>
              </v-btn>
            </template>
            Delete
          </v-tooltip>
          <v-tooltip
            bottom
            v-if="
              !item.emailVerified &&
                !item.userdeleted &&
                (item.enabled ||
                  item.roles[0] === 'provider' ||
                  item.roles[0] === 'institution-representative')
            "
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                x-small
                fab
                class="mr-2"
                color="white"
                @click="resendVerification(item)"
              >
                <v-icon>
                  mdi-email-check-outline
                </v-icon>
              </v-btn>
            </template>
            Resend Verification Email
          </v-tooltip>
        </v-layout>
      </template>
    </v-data-table>
    <v-dialog v-if="itemToBeDeleted !== null" v-model="deleteDialog" max-width="500">
      <v-card>
        <v-card-title class="headline">{{ $t(deleteLabel) }}</v-card-title>
        <v-card-text>
          {{ $t('delete.confirm') }}. Please type user email to confirm:
          <v-text-field outlined v-model="itemToBeDeletedConfirm"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            text
            @click="
              deleteDialog = false;
              itemToBeDeletedConfirm = null;
            "
          >
            {{ $t('cancel') }}
          </v-btn>
          <v-btn
            color="red darken-1"
            text
            @click="onDeleteItem"
            :disabled="disableDelete || itemToBeDeletedConfirm != itemToBeDeleted.email"
          >
            {{ $t(deleteLabel) }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import EventBus from '@/helpers/event-bus.js';
import util from '@/mixins/util.js';
// import VueJsonToCsv from 'vue-json-to-csv';

export default {
  name: 'TableUsers',
  // components: { VueJsonToCsv },
  mixins: [util],
  props: {
    urlApi: String,
    urlApiDisabled: String,
    search: Object,
    searchAttributes: Array,
    viewRouter: String,
    deleteLabel: {
      type: String,
      default: 'delete.message',
    },
  },
  data: () => ({
    firstLoad: true,
    totalItems: 0,
    items: [],
    loading: true,
    options: {},
    headers: [
      { text: '', value: 'actions', sortable: false },
      { text: 'Status', value: 'status', sortable: false },
      { text: 'First Name', value: 'firstName' },
      { text: 'Last Name', value: 'lastName' },
      { text: 'Institution', value: 'institution' },
      { text: 'Email', value: 'email' },
      { text: 'Role', value: 'roles', sortable: false },
      { text: 'Last Login', value: 'lastLogin' },
      { text: 'First Login', value: 'firstLogin' },
    ],
    footerProps: { 'items-per-page-options': [10, 15, 25, 50, 100] },
    tableKey: 0,
    itemToBeDeleted: null,
    deleteDialog: false,
    disableDelete: false,
    itemToBeDeletedConfirm: null,
    downloadLoading: false,
  }),
  watch: {
    options: {
      handler() {
        console.log('[Table] Options watch');
        if (!this.firstLoad) {
          this.changeOptions();
        }
      },
      deep: true,
    },
  },
  mounted() {
    console.log('[Table] Mounted');
    if (this.firstLoad) {
      /* Populate table from route */
      this.options.page = this.$route.query.index ? Number(this.$route.query.index) + 1 : 1;
      this.options.itemsPerPage = this.$route.query.size ? Number(this.$route.query.size) : 10;
      this.options.sortBy = [];
      this.options.sortDesc = [];
      if (this.$route.query.sort) {
        const sortList = this.$route.query.sort.split(',');
        for (let i = 0; i < sortList.length; i += 1) {
          this.options.sortBy.push(sortList[i].split(' ')[0]);
          if (sortList[i].split(' ')[1] === 'asc') {
            this.options.sortDesc.push(false);
          } else {
            this.options.sortDesc.push(true);
          }
        }
      }
      for (let i = 0; i < this.searchAttributes.length; i += 1) {
        const attr = this.searchAttributes[i];
        if (this.$route.query[attr]) {
          this.$set(this.search, attr, this.$route.query[attr]);
        }
      }
    }
    this.getDataFromApi().then(data => {
      this.items = JSON.parse(JSON.stringify(data.items));
      this.totalItems = data.total;
      this.firstLoad = false;
    });
  },
  methods: {
    triggerSearch() {
      console.log('[Table] Search watch');
      if (!this.firstLoad) {
        this.options.page = 1;
        this.changeOptions();
      }
    },
    changeOptions() {
      console.log('change options');
      this.$router
        .push({
          path: this.$router.path,
          query: this.getParams(),
        })
        .catch(err => {
          throw new Error(`Problem handling something: ${err}.`);
        });
      let currentPathName = this.$router.currentRoute.name;
      localStorage[currentPathName] = this.$router.currentRoute.fullPath;
    },
    getDataFromApi() {
      console.log('[Table] Loading data');
      this.loading = true;
      EventBus.$emit('waiting', true);
      return new Promise(resolve => {
        this.axios
          .get(`${this.urlApi}?`, {
            params: this.getParams(),
          })
          .then(res => {
            let items = [];
            let total = 0;
            if (res.status === 200) {
              items = res.data.content;
              total = res.data.total;
            }
            setTimeout(() => {
              this.loading = false;
              resolve({
                items,
                total,
              });
            });
          })
          .finally(() => {
            EventBus.$emit('waiting', false);
          });
      });
    },
    getParams() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      let query = {};
      if (!this.pageList) {
        query = {
          index: page - 1,
          size: itemsPerPage,
        };
      }
      let sort = '';
      for (let i = 0; i < sortBy.length; i += 1) {
        if (i !== 0) {
          sort += ',';
        }
        let dir = 'asc';
        if (sortDesc[i]) {
          dir = 'desc';
        }
        sort += `${sortBy[i]} ${dir}`;
      }
      if (sort !== '') {
        query.sort = sort;
      }
      for (let i = 0; i < this.searchAttributes.length; i += 1) {
        const attr = this.searchAttributes[i];
        if (this.search[attr]) {
          query[attr] = this.search[attr];
        }
      }
      // merge with external query
      let finalQuery = {
        ...query,
        ...this.externalQuery,
      };
      return finalQuery;
    },
    onViewItem(value) {
      console.log('Click View ' + value.id);
      this.$router.push({
        name: this.viewRouter,
        query: { id: value.id },
      });
    },
    resendVerification(item) {
      EventBus.$emit('waiting', true);
      this.axios
        .post('/api/v1/users/resend-verification', { id: item.id })
        .then(() => {
          console.log('Success');
          EventBus.$emit('snackbar', {
            text: 'Verification email sent successfully',
          });
        })
        .catch(error => {
          console.log({ error });
        })
        .finally(() => {
          EventBus.$emit('waiting', false);
        });
    },
    forceTableRerender() {
      this.tableKey += 1;
    },
    onDeleteItem() {
      this.disableDelete = true;
      let value = this.itemToBeDeleted;
      console.log('Click Delete ' + value.id);
      EventBus.$emit('waiting', true);
      this.axios
        .delete('/api/v1/users/' + value.id)
        .then(() => {
          console.log('Success');
          EventBus.$emit('snackbar', {
            text: this.$i18n.t('delete.success'),
          });
          this.deleteDialog = false;
          this.$emit('delete', value);
          this.disableDelete = false;
          this.itemToBeDeletedConfirm = null;
        })
        .catch(error => {
          console.log(error);
          this.disableDelete = false;
          EventBus.$emit('snackbar', {
            text: error.response.data,
            color: 'warning',
          });
        })
        .finally(EventBus.$emit('waiting', false));
    },
    downloadUsers() {
      this.downloadLoading = true;
      this.loading = true;
      EventBus.$emit('waiting', true);
      this.axios
        .post('api/v1/users/keycloak/download')
        .then(response => this.waitForUsersDownload(response.data.id))
        .then(exportId =>
          this.axios.get(`api/v1/users/keycloak/download/${exportId}/file`, {
            responseType: 'blob',
          }),
        )
        .then(response => {
          const contentDisposition = response.headers['content-disposition'];
          let fileName = 'users.xlsx';
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename="([^"]*)"/);
            if (fileNameMatch) {
              fileName = fileNameMatch[1];
            }
          }

          const url = window.URL.createObjectURL(new Blob([response.data]));

          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', fileName);

          document.body.appendChild(link);
          link.click();
          link.remove();
        })
        .catch(error => {
          console.error('Error downloading file:', error);
          EventBus.$emit('snackbar', {
            text: 'Error downloading file',
            color: 'warning',
          });
        })
        .finally(() => {
          EventBus.$emit('waiting', false);
          this.downloadLoading = false;
          this.loading = false;
        });
    },
    waitForUsersDownload(exportId) {
      return new Promise((resolve, reject) => {
        if (!exportId) {
          reject(new Error('Missing users export id'));
          return;
        }
        const poll = () => {
          this.axios
            .get(`api/v1/users/keycloak/download/${exportId}`)
            .then(response => {
              if (response.data.status === 'COMPLETED') {
                resolve(exportId);
              } else if (response.data.status === 'FAILED') {
                reject(new Error(response.data.errorMessage || 'Error creating Excel file'));
              } else {
                setTimeout(poll, 2000);
              }
            })
            .catch(reject);
        };
        poll();
      });
    },
    // getFirstName(fullName) {
    //   let nameParts = fullName.trim().split(' ');
    //   let firstName = nameParts[nameParts.length - 1];
    //   return firstName.charAt(0).toUpperCase() + firstName.slice(1);
    // },
    // getLastName(fullName) {
    //   let nameParts = fullName.trim().split(' ');
    //   let lastName = nameParts.slice(0, -1).join(' ');
    //   return lastName
    //     .split(' ')
    //     .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    //     .join(' ');
    // },
    getChipColor(item) {
      if (item.roles[0] === 'provider') {
        if (item.userdeleted) {
          return 'danger';
        } else if (!item.emailVerified) {
          return 'warning';
        } else if (!item.enabled) {
          return 'warning';
        } else if (!item.enabled && !item.emailVerified) {
          return 'danger';
        } else return 'success';
      }

      if (item.roles[0] === 'researcher') {
        if (item.userdeleted) {
          return 'danger';
        } else if (!item.emailVerified) {
          return 'warning';
        } else if (!item.enabled) {
          return 'warning';
        } else if (!item.enabled && !item.emailVerified) {
          return 'danger';
        } else return 'success';
      }

      if (item.roles[0] === 'institution-representative') {
        if (item.userdeleted) {
          return 'danger';
        } else if (!item.emailVerified) {
          return 'warning';
        } else if (!item.enabled) {
          return 'warning';
        } else if (!item.enabled && !item.emailVerified) {
          return 'danger';
        } else return 'success';
      }
    },
    getChipText(item) {
      if (item.roles[0] === 'provider') {
        if (item.userdeleted) {
          return 'Disabled by User';
        } else if (!item.emailVerified) {
          return 'Email is not verified';
        } else if (!item.enabled) {
          return 'Pending registration';
        } else if (!item.enabled && !item.emailVerified) {
          return 'Disabled';
        } else return 'Enabled';
      }

      if (item.roles[0] === 'researcher') {
        if (item.userdeleted) {
          return 'Disabled by User';
        } else if (!item.emailVerified) {
          return 'Email is not verified';
        } else if (!item.enabled) {
          return 'Pending registration';
        } else if (!item.enabled && !item.emailVerified) {
          return 'Disabled';
        } else return 'Enabled';
      }

      if (item.roles[0] === 'institution-representative') {
        if (item.userdeleted) {
          return 'Disabled by User';
        } else if (!item.emailVerified) {
          return 'Email is not verified';
        } else if (!item.enabled) {
          return 'Pending registration';
        } else if (!item.enabled && !item.emailVerified) {
          return 'Disabled';
        } else return 'Enabled';
      }
    },
  },
};
</script>

<style>
.v-application--is-ltr .v-data-table__mobile-row__cell {
  text-align: left;
}

.v-data-table-header th {
  white-space: nowrap;
  text-align: left;
  vertical-align: middle;
}

#table-providers
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td:first-child {
  width: 97px !important;
}
</style>
